import React, { useMemo, useRef } from 'react';
import styles from './index.module.less';
import { Image } from 'antd';
import arrowBottom from 'assets/imgs/arrow_bottom.png';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { useScroll, useSize } from 'ahooks';

gsap.registerPlugin(useGSAP);

const ScrollArrow = React.memo((props) => {
  const scrollArrowRef = useRef<HTMLDivElement>(null);

  const scroll = useScroll(document);
  const size = useSize(document.querySelector('body'));

  const isScrollBottom = useMemo(() => {
    if (!scroll || !size) {
      return false;
    }
    return document.documentElement.scrollHeight - scroll.top - size.height < 300;
  }, [scroll, size]);

  useGSAP(
    () => {
      gsap.to(scrollArrowRef.current, {
        y: -10, // 向上移动 20px
        duration: 0.6, // 动画时长 0.6 秒
        repeat: -1, // 无限循环
        yoyo: true, // 反向播放，使箭头上下跳动
        ease: 'power1.inOut', // 缓动效果
      });
    },
    { scope: scrollArrowRef },
  );

  if (isScrollBottom) {
    return null;
  }

  return (
    <div className={styles.scrollArrow} ref={scrollArrowRef}>
      <div className={styles.scrollArrowContent}>
        <Image className="cursor-pointer" src={arrowBottom} preview={false} width=".32rem" />
        <br />
        <span className="cursor-pointer">scroll to discover</span>
      </div>
    </div>
  );
});

export default ScrollArrow;
